const BASE_URL = 'https://s3-us-east-2.amazonaws.com/polimorphic-sha256/'

export const images = {
  caselle: BASE_URL + 'assets/caselle.png',
  cityworks: BASE_URL + 'assets/cityWorks.png',
  civicPlus:
    BASE_URL +
    '910d3d9dd3b15042afd1af00adb0c04c5bf6f9d9a7ee9d1bd464716568fd8f5b/civicplus-logo.png',
  logo: BASE_URL + 'dbe8e0d32fca2d0ef814855cb032ca98d54516d6d854e2b6ecaff7a39f42bdf4.svg',
  logoWhite:
    BASE_URL + 'f8b4df5e9c54e7968f1dd317f5ad00caaa6ce6d4cac2e2dd305f34ee87abebef%2FlogoWhite.svg',
  textLogo: BASE_URL + '142c637bc1bef781aa9019e9ab70191cbf47c23f3bd52aecaccd128fcf326283.svg',
  altTextLogo:
    BASE_URL + '40627827d5b70246f4e52f23538d8e56e05fd7a728a312c2d3efe5591461993b%2FaltLogo.svg',
  loadingSpinner: BASE_URL + 'assets/loading.gif',
  governmentBuilding:
    BASE_URL + '4d94ab3a83b59b3e260fcd9ab5e99c52eb07abaf85e1cc28daae9014be1da68c/government.jpg',
  granicus:
    BASE_URL + '21ab0ec77579b3643e6bac2f9417bd27b47149deefa02b0689b4dae2399bc853/granicus-logo.png',
  orgDefaultBanner: BASE_URL + 'assets/isometricCity.png',
  onboardingDefault:
    BASE_URL +
    '195b7d5ca4d8ef54c99893437b2b774eec2cba7bb78308f1aae6d88b037f3ae2/onboarding_default.jpg',
  proudcity:
    BASE_URL +
    '0a3038f8e6dd891c3a20fb9cb4b01904cc81a73b0ee0882edb96e9b811b322bc/proudcity-logo.png',
  revize: BASE_URL + 'assets/revize.jpg',
  southern: BASE_URL + 'assets/southern.png',
  springbrook: BASE_URL + 'assets/springbrook.jpeg',
  townScene:
    BASE_URL + '22c9ab822cd3f94e7d0c37bdb8888a88bc34686bdcae2e60ea9c7148b7de0a62/town_scene.svg',
  tylerTech: BASE_URL + 'assets/tylerTech.png',
  usFlag: BASE_URL + 'assets/usFlag.svg',
  utilities: BASE_URL + 'assets/utilities.svg',
  nemrc: BASE_URL + 'assets/nemrc.jpg',
  quietStreetGraphic:
    BASE_URL +
    '5e7c1d6c3e0bc9c84c6936bdaf3d53d1b35b11f595cca4467b6b1efeca4c39e9/Quiet_Street_graphic.svg',
  greenBlob:
    BASE_URL + 'cbe7452c56a64030c1523fe2cd7725d6f9ac82a164eb808a4d08cd9076073c53/Green_blob.svg',
  blueBlob:
    BASE_URL + '8c945625ff4975f641ee0d49a2d9cc376376f5b6fe286a5e329421e3e3a45c37/Blue_blob.svg',
  titaniumBlob:
    BASE_URL + '4fb28686592f59bdaa5732d5af55bde3d865934eb18344df521f1c5248d4c0da/Titanium_blob.svg',
}
